import { PropsWithChildren } from "react";
import { CardHeader } from "@/components/ui/card";

const DescriptionListHeader = ({ children }: PropsWithChildren) => {
  return <CardHeader className="pb-0">{children}</CardHeader>;
};

export default DescriptionListHeader;
